import classNames from 'classnames';
import { Form, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { Button } from 'yoso';
import { Adventure } from '~/components/Adventure/Adventure.hooks';
import { AdventureCountField } from '~/components/Adventure/Form/Count/AdventureCountField';
import { useBalance } from '~/components/Balance/Balance.hooks';
import { breakpoints, useIsSmallerThan } from '~/components/Breakpoint/Breakpoint.hook';
import { BaseCard } from '~/components/Card';
import { T } from '~/components/I18n';
import { styles as bottomSheetStyles } from '~/components/Modal/BottomSheet/BottomSheet';
import styles from './AdventureForm.module.scss';

export type AdventureFormProps = {
  className?: string;
} & Pick<Adventure, 'id'>;
export const AdventureForm = ({ id, className }: AdventureFormProps) => {
  const {
    data: { amount: balance },
  } = useBalance();
  const { setFieldValue, isSubmitting, isValid } = useFormikContext();
  const isMobile = useIsSmallerThan(breakpoints.large);
  const disabled = !isValid || isSubmitting;

  useEffect(() => {
    setFieldValue('balance', balance);
  }, [balance, setFieldValue]);

  return (
    <Form className={classNames(styles.root, className)}>
      <BaseCard className={styles.body} shadow>
        <AdventureCountField id={id} autoFocus={!isMobile} />
      </BaseCard>
      <div className={styles.footer}>
        <Button
          type="submit"
          disabled={disabled}
          color="primary"
          block
          className={classNames(bottomSheetStyles.confirmButton, styles.button)}
          size="large">
          <T name="citizen_adventure_participate" />
        </Button>
      </div>
    </Form>
  );
};
